import { useToolbarContext } from './useToolbarContext'

export function useToolbarState() {
    const { recordsSelectedCount, isTrashMode, isFiltersPaneOpen } = useToolbarContext()
    const hasRecordsSelected = recordsSelectedCount > 0

    return {
        hasRecordsSelected,
        isTrashMode,
        isFiltersPaneOpen,
    }
}
